if ($('.type-detail').length) {
    if ($('.admin-logged').length) {
        const product = getShoptetDataLayer('product');
        if (product && product.codes) {
            let skladovyHtml = '<div class="dataLayerInfo"><ul>';
            product.codes.forEach(variant => {
                skladovyHtml += `<li data-code="${variant.code}" style="display:none;"><ul>`;
                if (variant.stocks && variant.stocks.length) {
                    variant.stocks.forEach(stock => {
                        const sklad = getShoptetDataLayer('stocks')?.find(s => s.id == stock.id);
                        let skladNazev = sklad ? sklad.title : `Sklad ID ${stock.id}`;
                        if (skladNazev === 'Sklad') {
                            skladNazev = '<strong class="show-tooltip" data-title="'+tooltipDodavatel+'" data-original-title="'+tooltipDodavatel+'">Dodavatel</strong>';
                        }
                        else if (skladNazev === 'Bikeclinic') {
                            skladNazev = '<strong>U nás</strong>';
                        }
                        skladovyHtml += `<li>${skladNazev}: ${stock.quantity} ks</li>`;
                    });
                } else {
                   // skladovyHtml += '<li>Žádné skladové informace</li>';
                }
                skladovyHtml += '</ul></li>';
            });
            skladovyHtml += '</ul></div>';
            $('.p-info-wrapper .availability-value').append(skladovyHtml);
        }
        document.addEventListener('ShoptetSplitVariantParameterChange', function() {
            displayCode = $('.p-info-wrapper>.p-code>span:not(.p-code-label):not(.no-display)').text().trim()
            $('.dataLayerInfo>ul>li').hide();
            $('.dataLayerInfo>ul>li[data-code="'+displayCode+'"]').show();
        });
        const variantData = shoptet.variantsSplit.necessaryVariantData;
        $('.custom-variants .variant').each(function () {
            const $variantEl = $(this);
            const valueId = $variantEl.data('value');
            const label = $.trim($variantEl.text());
            if (!valueId) return;
            let matchedEntry;
            for (let paramId of allowedParameterIds) {
                matchedEntry = Object.entries(variantData).find(([key]) => {
                    return key.includes(`${paramId}-${valueId}`);
                });
                if (matchedEntry) break;
            }

            if (matchedEntry) {
                const [key, data] = matchedEntry;
                const imageUrl = data.variantImage?.detail_small || data.variantImage?.detail;

                if (imageUrl) {
                    const $img = $(`<img src="${imageUrl}" alt="${label}">`);
                    $variantEl.addClass('imageVariant').prepend($img);
                }
            }
        });
    }
    initTooltips();
}
